import { Navigate, useLocation } from "react-router-dom"
import { useSubscription } from "@/lib/contexts/SubscriptionContext"

// Pages an agent-plan account keeps in the web app: keys and MCP, connectors,
// site/workspace settings. Everything else (analytics, heatmaps, funnels,
// experiments, the hub) is done by the agent, so those routes go to /agent.
const ACCOUNT_PAGES = /\/(api|connectors|settings)(\/|$)/

/**
 * Rendered inside DashboardLayout and HubShell. Free start and Agents accounts
 * get the full product through the API and MCP, but the web app is account
 * management only on those plans.
 */
export function AgentPlanRedirect() {
  const { isAgentPlan, isLoading } = useSubscription()
  const { pathname } = useLocation()
  if (isLoading || !isAgentPlan || ACCOUNT_PAGES.test(pathname)) return null
  return <Navigate to="/agent" replace />
}
